import { render, staticRenderFns } from "./TravelNicheIcon.vue?vue&type=template&id=1e49e07f&scoped=true"
import script from "./TravelNicheIcon.vue?vue&type=script&lang=js"
export * from "./TravelNicheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e49e07f",
  null
  
)

export default component.exports